// extracted by mini-css-extract-plugin
export default {"container":"modal_container__84f54","btnClose":"modal_btnClose__N0JYk","logo":"modal_logo__jfzSv","modal_fadeInOut__zXkmT":"modal_modal_fadeInOut__zXkmT__rIYHC"};